import { apiClient } from './client';
import type { Unit } from '../types/unit';

/**
 * Get all active product units
 * @returns Array of active product units
 */
export const getUnits = async (): Promise<Unit[]> => {
  const response = await apiClient.get<Unit[]>('/units');
  return response;
};
